import api from '../../../services/api';
import type { SupplierOrderManualLandedCostCategory } from '../../../dto/supplierOrder';

export interface SupplierDefaultCost {
  id: string;
  supplierId: string;
  category: SupplierOrderManualLandedCostCategory;
  amount: number;
  currency: string;
  note?: string | null;
  sortOrder?: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface SupplierDefaultCostPayload {
  category: SupplierOrderManualLandedCostCategory;
  amount: number;
  currency: string;
  note?: string | null;
  sortOrder?: number;
}

// The backend may respond with either a bare array or a { defaultCosts: [...] }
// envelope — normalize here so callers never have to guess the shape.
function unwrapDefaultCosts(data: unknown): SupplierDefaultCost[] {
  if (Array.isArray(data)) {
    return data;
  }
  if (data && typeof data === 'object' && Array.isArray((data as any).defaultCosts)) {
    return (data as any).defaultCosts;
  }
  return [];
}

export async function fetchSupplierDefaultCosts(
  supplierId: string
): Promise<SupplierDefaultCost[]> {
  const response = await api.get(`/suppliers/${supplierId}/default-costs`);
  return unwrapDefaultCosts(response.data);
}

export async function createSupplierDefaultCost(
  supplierId: string,
  payload: SupplierDefaultCostPayload
): Promise<SupplierDefaultCost> {
  const response = await api.post(`/suppliers/${supplierId}/default-costs`, payload);
  return response.data;
}

export async function updateSupplierDefaultCost(
  supplierId: string,
  costId: string,
  payload: SupplierDefaultCostPayload
): Promise<SupplierDefaultCost> {
  const response = await api.put(`/suppliers/${supplierId}/default-costs/${costId}`, payload);
  return response.data;
}

export async function deleteSupplierDefaultCost(
  supplierId: string,
  costId: string
): Promise<void> {
  await api.delete(`/suppliers/${supplierId}/default-costs/${costId}`);
}
